import median from 'ml-array-median';
import { xRolling } from './xRolling';
/**
 * This function calculates a rolling average
 *
 * @param array - the array that will be rotated
 * @param options - options
 */
export function xRollingMedian(array, options = {}) {
    return xRolling(array, median, options);
}
//# sourceMappingURL=xRollingMedian.js.map